import { render, staticRenderFns } from "./iOnlyU.vue?vue&type=template&id=f7e839b2&scoped=true"
import script from "./iOnlyU.vue?vue&type=script&lang=js"
export * from "./iOnlyU.vue?vue&type=script&lang=js"
import style0 from "./iOnlyU.vue?vue&type=style&index=0&id=f7e839b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7e839b2",
  null
  
)

export default component.exports